module.exports = __webpack_public_path__ + "media/images/social-share-button/email-d79a53d1d223015094db02a5d955557f.svg";